var _a, _b;
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { Resource, detectResourcesSync, browserDetectorSync, } from "@opentelemetry/resources";
import { WebTracerProvider, BatchSpanProcessor, ConsoleSpanExporter, } from "@opentelemetry/sdk-trace-web";
import { SemanticResourceAttributes } from "@opentelemetry/semantic-conventions";
import { SentryPropagator, SentrySpanProcessor, } from "@sentry/opentelemetry-node";
import * as Sentry from "@sentry/react";
import { sentryBrowserOptions } from "./options";
import { sentryOtelConfig } from "./sentry";
let spanProcessor;
let propagator;
const appName = process.env.REACT_APP_APP_NAME ||
    process.env.NEXT_PUBLIC_APP_NAME ||
    process.env.APP_NAME;
const gitVersion = (_a = process.env.GITHUB_SHA) !== null && _a !== void 0 ? _a : "dev";
const otelDisabled = (process.env.REACT_APP_OTEL_DISABLED ||
    process.env.NEXT_PUBLIC_OTEL_DISABLED ||
    process.env.OTEL_DISABLE ||
    "false") === "true";
if (sentryOtelConfig.dsn) {
    // @ts-ignore
    Sentry.init({
        ...sentryOtelConfig,
        release: `${appName}@${gitVersion}`,
        ...sentryBrowserOptions,
    });
    spanProcessor = new SentrySpanProcessor();
    propagator = new SentryPropagator();
}
else {
    spanProcessor = new BatchSpanProcessor(new ConsoleSpanExporter());
}
let resource = new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: appName || "react-fe-app",
});
const detectedResources = detectResourcesSync({
    detectors: [browserDetectorSync],
});
resource = resource.merge(detectedResources);
const provider = new WebTracerProvider({
    resource,
});
if (!otelDisabled) {
    provider.addSpanProcessor(spanProcessor);
    provider.register({ propagator });
    registerInstrumentations({
        tracerProvider: provider,
        instrumentations: [
            getWebAutoInstrumentations({
                "@opentelemetry/instrumentation-fetch": {
                    propagateTraceHeaderCorsUrls: (_b = sentryOtelConfig.tracePropagationTargets) === null || _b === void 0 ? void 0 : _b[0],
                    clearTimingResources: true,
                    // applyCustomAttributesOnSpan(span) {
                    //   span.setAttribute("app.synthetic_request", "false");
                    // },
                },
            }),
        ],
    });
}
export default provider;
